import React from 'react';
import { CircularProgress, MenuItem } from '@mui/material';
import Button from '../../../../../../components/Button';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/redux';
import { TState } from '../../../../types';
import Menu from '../../../../../../components/Menu';
import { EChangeCutOffTime } from '../../types';
import { ReactComponent as CancelIcon } from '../../../../images/cancel.svg';
import { ReactComponent as EditlIcon } from '../../../../images/edit.svg';
import { cutOffTimeSlice, deleteCutOffTime } from '../../../../../../store/reducers/cutOffTimeSlice';
import css from './CutOffTimeList.module.scss';
import { intregrationSlice } from '../../../../../../store/reducers/integrationSlice';

type TCutOffTime = {
  setState: React.Dispatch<React.SetStateAction<TState>>;
  setChangeState: React.Dispatch<React.SetStateAction<EChangeCutOffTime>>;
};

export const CutOffTimeList = ({ setState, setChangeState }: TCutOffTime) => {
  const dispatch = useAppDispatch();
  const { setEditIntegrationId } = intregrationSlice.actions;
  const { setEditCcyId, setIsLoading } = cutOffTimeSlice.actions;
  const { intregrations, paramsId } = useAppSelector((state) => state.integrationReducer);
  const { cutOffTime, loading } = useAppSelector((state) => state.cutOffTimeReducer);
  const intregration = intregrations?.find((item) => item.paramsId === paramsId);
  const editCutOffTime = (ccyId: string) => {
    dispatch(setEditCcyId(ccyId));
    setChangeState(EChangeCutOffTime.EDIT)
  };

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <section className={css.root}>
      <Button onClick={() => setChangeState(EChangeCutOffTime.ADD)}>+ Add new</Button>
      <div className={css.channel}>
        <b>Channel:&nbsp;</b>
        {intregration?.name}
      </div>
      <div className={css.table}>
        <div className={css.head}>
          <div className={css.col1}>Currency</div>
          <div className={css.col2}>Time</div>
        </div>
        <ul className={css.body}>
          {cutOffTime?.map((item, index) => (
            <li key={`cutOffTime_${index}`} className={css.item}>
              <div className={css.col1}>{item.currency}</div>
              <div className={css.col2}>{item.time}</div>
              <div className={css.buttons}>
                <Menu>
                  <MenuItem disableRipple onClick={() => editCutOffTime(item.ccyId)}>
                    <EditlIcon className={css.icon} />
                    Edit
                  </MenuItem>
                  <MenuItem
                    disableRipple
                    onClick={() => dispatch(deleteCutOffTime({ ccyId: item.ccyId}))}
                  >
                    <CancelIcon className={css.icon} />
                    Cancel
                  </MenuItem>
                </Menu>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <Button
        onClick={() => {
          // need for loading state reset
          dispatch(setIsLoading(true));

          dispatch(setEditIntegrationId(null));
          setState(TState.INTEGRATIONS);
        }}
      >
        Back
      </Button>
    </section>
  );
};
